/**
 * This file is maily for creating a dialog to create new template from an editor
 */
import React, { useState, useLayoutEffect, useEffect } from "react";
import {
	TextField,
	DialogHandler,
	Button,
} from "cakemail-ui-components/lib/react";
import { I18n, Translate } from "react-redux-i18n";

const TemplateDialog = (props) => {
	const [text, setText] = useState("");
	const [textSubject, setTextSubject] = useState("");
	const [valid, setValid] = useState(props.initialValid);
	function handleAreaChange(e) {
		const value = e.currentTarget.value;
		setText(value);
		if (props.isValidValue(value)) {
			setValid("valid");
		} else setValid("");
	}
	function handleSubjectChange(e) {
		const value = e.currentTarget.value;
		setTextSubject(value ? value : null);
		if (!value || props.isValidValue(value)) {
			setValid("valid");
		} else {
			setValid("");
		}
	}

	useEffect(() => {
		setTextSubject(props.initialSubject || "");
		setText(props.initialValue || "");
	}, [props.initialSubject, props.initialValue]);

	useLayoutEffect(() => {
		setTimeout(
			() =>
				document
					?.getElementById("createTemplateArea")
					?.getElementsByTagName("input") &&
				document
					.getElementById("createTemplateArea")
					.getElementsByTagName("input")[0]
					.focus(),
			50
		);
	}, []);
	return (
		<>
			<TextField
				onKeyUp={(e) => {
					if (props.isValidValue(e.currentTarget.value))
						if (e.keyCode === 13) {
							props.primaryBtnClick(text, textSubject);
						}
				}}
				className="createTemplateInput"
				id="createTemplateArea"
				label={props.textLabel}
				placeholder={
					props.textPlaceholder
						? I18n._translate(props.textPlaceholder)
						: I18n._translate(
							"app-campaigns-flow-editor_template-name_placeholder"
						)
				}
				value={text}
				onChange={handleAreaChange}
				valid={valid}
				message={
					valid === "valid" ? I18n._translate("app-auth_validators_valid") : ""
				}
			/>
			{props.createTemplate && (
				<>
					<br />
					<TextField
						className="createTemplateInput"
						id="createTemplateArea"
						label={I18n._translate("app-templates-create-subject")}
						placeholder={I18n._translate("app-templates-create-subject-placeholder")}
						value={textSubject}
						onChange={handleSubjectChange}
						valid={valid}
						message={
							valid === "valid" ? I18n._translate("app-auth_validators_valid") : ""
						}
					/>
				</>
			)
			}
			<div className="dialogBtns">
				<Button
					shapeStyle="stroke"
					colorTheme="grey"
					size="small"
					radius="square"
					text={props.secondaryBtnText}
					onClick={props.secondaryBtnClick}
				/>
				<Button
					shapeStyle="fill"
					colorTheme="teal"
					size="small"
					radius="square"
					text={props.primaryBtnText}
					onClick={() => {
						props.primaryBtnClick(text, textSubject);
					}}
					disabled={valid === ""}
				/>
			</div>
		</>
	);
};

export default TemplateDialog;

TemplateDialog.TemplateDialog = {
	initialValue: "",
	rename: false,
};
const createTemplateTextStringsIds = {
	dialogTitle: "app-campaigns-flow-editor_template-name_title",
	primaryBtnText: "app-campaigns-flow-editor_template-name_title",
	secondaryBtnText: "app-general-cancel",
	renameTextFieldLabel: "app-campaigns-flow-editor_template-name_label",
	textFieldPlaceholder: "app-campaigns-flow-editor_template-name_placeholder",
};
export const CreateTemplateDialogHandler = (
	callback,
	textStringsIds = createTemplateTextStringsIds
) => {
	DialogHandler.show({
		managedByContent: true,
		title: I18n._translate(textStringsIds.dialogTitle || createTemplateTextStringsIds.dialogTitle),
		content: (
			<TemplateDialog
				primaryBtnText={I18n._translate(textStringsIds.primaryBtnText || createTemplateTextStringsIds.primaryBtnText)}
				secondaryBtnText={I18n._translate(textStringsIds.secondaryBtnText || createTemplateTextStringsIds.secondaryBtnText)}
				secondaryBtnClick={() => {
					DialogHandler.hide();
				}}
				primaryBtnClick={(templateName, templateSubject) => {
					callback(templateName, templateSubject);
					DialogHandler.hide();
				}}
				isValidValue={(value) => value !== "" && value}
				textLabel={<Translate value={textStringsIds.renameTextFieldLabel || createTemplateTextStringsIds.renameTextFieldLabel} />}
				initialValue=""
				createTemplate={true}
				initialValid={""}
				textPlaceholder={textStringsIds.textFieldPlaceholder || createTemplateTextStringsIds.textFieldPlaceholder}
			/>
		),
	});
};
const renameTemplateTextStringsIds = {
	dialogTitle: "app-campaigns-flow-editor_template-rename_title",
	primaryBtnText: "app-campaigns-flow-editor_template-rename_title",
	secondaryBtnText: "app-general-cancel",
	renameTextFieldLabel: "app-campaigns-flow-editor_template-rename_text",
};
export const RenameTemplateDialogHandler = (
	templateName,
	subject,
	callback,
	textStringsIds = renameTemplateTextStringsIds
) => {
	DialogHandler.show({
		managedByContent: true,
		title: I18n._translate(textStringsIds.dialogTitle),
		content: (
			<TemplateDialog
				primaryBtnText={I18n._translate(textStringsIds.primaryBtnText)}
				secondaryBtnText={I18n._translate(textStringsIds.secondaryBtnText)}
				isValidValue={(value) => value !== templateName && value != "" && value}
				initialValid={""}
				secondaryBtnClick={() => {
					DialogHandler.hide();
				}}
				primaryBtnClick={(newTemplateName, newSubject) => {
					callback(newTemplateName, newSubject);
					DialogHandler.hide();
				}}
				textLabel={I18n._translate(textStringsIds.renameTextFieldLabel)}
				initialValue={templateName}
				initialSubject={subject}
				createTemplate={true}
			/>
		),
	});
};


export const RenameAutomationDialogHandler = (
	templateName,
	callback,
	textStringsIds = renameTemplateTextStringsIds
) => {
	DialogHandler.show({
		managedByContent: true,
		title: I18n._translate(textStringsIds.dialogTitle),
		content: (
			<TemplateDialog
				primaryBtnText={I18n._translate(textStringsIds.primaryBtnText)}
				secondaryBtnText={I18n._translate(textStringsIds.secondaryBtnText)}
				isValidValue={(value) => value !== templateName && value != "" && value}
				initialValid={""}
				secondaryBtnClick={() => {
					DialogHandler.hide();
				}}
				primaryBtnClick={(newTemplateName) => {
					callback(newTemplateName);
					DialogHandler.hide();
				}}
				textLabel={I18n._translate(textStringsIds.renameTextFieldLabel)}
				initialValue={templateName}
			/>
		),
	});
};

export const RenameCampaignDialogHandler = (
	templateName,
	callback,
	textStringsIds = renameTemplateTextStringsIds
) => {
	DialogHandler.show({
		managedByContent: true,
		title: I18n._translate(textStringsIds.dialogTitle),
		content: (
			<TemplateDialog
				primaryBtnText={I18n._translate(textStringsIds.primaryBtnText)}
				secondaryBtnText={I18n._translate(textStringsIds.secondaryBtnText)}
				isValidValue={(value) => value !== templateName && value != "" && value}
				initialValid={""}
				secondaryBtnClick={() => {
					DialogHandler.hide();
				}}
				primaryBtnClick={(newTemplateName) => {
					callback(newTemplateName);
					DialogHandler.hide();
				}}
				textLabel={I18n._translate(textStringsIds.renameTextFieldLabel)}
				initialValue={templateName}
			/>
		),
	});
};

export const DuplicateTemplateDialogHandler = (templateName, callback) => {
	DialogHandler.show({
		managedByContent: true,
		title: I18n._translate(
			"app-campaigns-flow-editor_template-duplicate_title"
		),
		content: (
			<TemplateDialog
				primaryBtnText={I18n._translate(
					"app-campaigns-flow-editor_template-duplicate_btn"
				)}
				secondaryBtnText={I18n._translate("app-general-cancel")}
				// any value here for the initialvalid would be ok, just need to avoid "" and 'valid'
				initialValid="maybe"
				isValidValue={(value) => value != "" && value}
				textLabel={I18n._translate(
					"app-campaigns-flow-editor_template-duplicate_text"
				)}
				initialValue={
					templateName +
					` ${I18n._translate("app-campaigns-templates-duplicate_copy")}`
				}
				secondaryBtnClick={() => {
					DialogHandler.hide();
				}}
				primaryBtnClick={(newTemplateName) => {
					callback(newTemplateName);
					DialogHandler.hide();
				}}
			/>
		),
	});
};